export const mesiIt = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']
export const mesiBreviIt = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic']
export const giorniIt = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica']
// const giorniBreviIt = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom']

// cache casalinga per non dover ricaricare ogni volta il colore del testo per un relativo background, se l'ho già fatto in precedenza
let cachedColors = {};

export function getUtenteFromToken(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    var usr = JSON.parse(jsonPayload);
    return usr && usr.user;
}

export function getTimestampFormattato(data) {
    if (!data || data === '') {
        return '';
    }
    return data.substring(8, 10) + '/' + data.substring(5, 7) + '/' + data.substring(0, 4) + (data.length > 10 ? data.substring(10, 16) : '');
}

export function getDataFormattata(data) {
    if (!data || data === '') {
        return '';
    }
    return data.substring(8, 10) + '/' + data.substring(5, 7) + '/' + data.substring(0, 4);
}

export function getDataPerDb(data) {
    if (!data) {
        return null;
    }
    return data.substring(6, 10) + '-' + data.substring(3, 5) + '-' + data.substring(0, 2);
}

export function convertiDateInDataPerDb(data) {
    if (data) {
        data = new Date(data)
    }

    return data ? [
        data.getFullYear(),
        (data.getMonth() + 1).toString().padStart(2, '0'),
        data.getDate().toString().padStart(2, '0')
    ].join('-') : null;
}

export function convertiTimestampInDataPerDb(data) {
    let d = convertiDateInDataPerDb(data)
    if (d) {
        if (data) {
            data = new Date(data)
        }

        d += ' ' + [
            data.getHours().toString().padStart(2, '0'),
            data.getMinutes().toString().padStart(2, '0'),
            data.getSeconds().toString().padStart(2, '0')
        ].join(':')
    }
    return d;
}

export function getLunedi(data) {
    var d = new Date(data.getTime());
    var day = d.getDay()
    var diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
}

export function getDomenica(d) {
    var lunedi = getLunedi(d);
    var diff = lunedi.getDate() + 6;
    return new Date(d.setDate(diff));
}

export function aggiungiGiorno(data) {
    var d = new Date(data.getTime());
    var diff = d.getDate() + 1;
    return new Date(d.setDate(diff));
}

export function sottraiGiorno(data) {
    return sottraiGiorni(data, 1);
}

export function sottraiGiorni(data, giorni) {
    var d = new Date(data.getTime());
    var diff = d.getDate() - giorni;
    return new Date(d.setDate(diff));
}

export function aggiungiMese(data) {
    var d = new Date(data.getTime());
    return new Date(d.setMonth(d.getMonth() + 1));
}

export function sottraiMese(data) {
    var d = new Date(data.getTime());
    return new Date(d.setMonth(d.getMonth() - 1));
}

export function getDataJsFormattata(d) {
    return [
        d.getDate().toString().padStart(2, '0'),
        (d.getMonth() + 1).toString().padStart(2, '0'),
        d.getFullYear()
    ].join('/')
}

export function getTimeDataJs(d) {
    let date = new Date(d);
    date.setHours(0, 0, 0, 0);
    return date.getTime()
}

export function getAnno(d) {
    let date = new Date(d);
    date.setDate(1)
    return date.getFullYear()
}

export function getMese(d) {
    let date = new Date(d);
    date.setDate(1)
    let mese = date.getMonth();
    return mesiIt[mese] + ' ' + date.getFullYear()
}

export function getMeseAbbreviato(d) {
    let date = new Date(d);
    date.setDate(1)
    let mese = date.getMonth();
    return mesiBreviIt[mese]
}

export function getGiorno(d) {
    let date = new Date(d);
    let giorno = date.getDay();
    return giorniIt[giorno]
}

/*----------------------------------------------*/

export function dateToMilliseconds(str){
    let d = new Date(str);
    return d.getTime();
}
/*------------------------------------------------------*/

export function getStrRgba(strColore) {
    if (!strColore || strColore === '') {
        strColore = '{"r":255,"g":255,"b":255,"a":1}';
    }
    let colore = JSON.parse(strColore);
    return "rgba("
        + colore.r + ", "
        + colore.g + ", "
        + colore.b + ", "
        + colore.a + ")";
}

export function getAnni(startYear, anniInFuturo = 0) {
    var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1920;
    while (startYear <= (currentYear + anniInFuturo)) {
        years.push(startYear++);
    }
    return years;
}

export function scadenza_warning(num){
    return (num * 30 * 24 * 60 * 60 * 1000);
}

// luminance del colore in input, ha senso solo per colori con alpha=1
// https://www.w3.org/WAI/GL/wiki/Relative_luminance
function getLuminance(colore) {

    let luminance = {};

    for (let componente in colore) {

        // ignoro alpha, dovrei avere solo colori piatti
        if (componente === 'a') {
            continue;
        } else {

            let componenteDecimal = colore[componente] / 255;

            let luminanceComponente = componenteDecimal <= 0.03928 ? (componenteDecimal / 12.92) : Math.pow((componenteDecimal + 0.055) / 1.055, 2.4);
            luminance[componente] = luminanceComponente;
        }
    }

    return 0.2126 * luminance.r + 0.7152 * luminance.g + 0.0722 * luminance.b;
}

// contrasto tra due colori in input
// https://www.w3.org/WAI/GL/wiki/Contrast_ratio
function getContrastRatio(colore1, colore2) {

    let luminance1 = getLuminance(colore1);
    let luminance2 = getLuminance(colore2);

    let luminanceLighter = Math.max(luminance1, luminance2);
    let luminanceDarker = Math.min(luminance1, luminance2);

    return (luminanceLighter + 0.05) / (luminanceDarker + 0.05);
}

function getTextColorForBackground(backgroundColorStr) {

    // passo alpha 1 visto che ragiono sempre in rgba
    // il "nero" è il colore base dei testi di manù
    const BLACK = {r: 33, g: 37, b: 41, a: 1};
    const WHITE = {r: 255, g: 255, b: 255, a: 1};

    if (!backgroundColorStr) {
        return BLACK;
    }

    let backgroundColor = JSON.parse(backgroundColorStr);

    // se il colore ha alpha la definizione di luminance e contrasto non ha senso, restituisco nero
    if (backgroundColor.a !== 1) {
        return BLACK;
    }

    // restituisco il colore che ha il contrasto maggiore con il colore in input
    return getContrastRatio(backgroundColor, BLACK) > getContrastRatio(backgroundColor, WHITE)
        ? BLACK
        : WHITE;
}

/**
 * restituisce la stringa rgba corrispondente al colore del testo (bianco o nero) con contrasto maggiore con il colore in input
 * @param {string} backgroundColorStr stringa con il colore in json rgba (come restituito da db)
 * @returns
 */
export function getTextColorForBackgroundStrRgba(backgroundColorStr) {
    if (!backgroundColorStr) {
        return "rgba(33, 37, 41, 1)"; // Default nero
    }

    if (cachedColors[backgroundColorStr]) {
        return cachedColors[backgroundColorStr];
    }

    let backgroundColor;

    if (backgroundColorStr.startsWith('#')) {
        backgroundColor = hexToRgba(backgroundColorStr);
    } else {
        try {
            backgroundColor = JSON.parse(backgroundColorStr);
        } catch (e) {
            console.error("Formato colore non supportato", backgroundColorStr);
            return "rgba(33, 37, 41, 1)"; // Default nero
        }
    }

    // Nota: passiamo l'oggetto direttamente a getTextColorForBackground
    // (potrebbe servire un piccolo refactor interno alla funzione se si aspetta ancora una stringa)
    const BLACK = {r: 33, g: 37, b: 41, a: 1};
    const WHITE = {r: 255, g: 255, b: 255, a: 1};

    const textColor = getContrastRatio(backgroundColor, BLACK) > getContrastRatio(backgroundColor, WHITE)
        ? BLACK
        : WHITE;

    const colorStr = `rgba(${textColor.r}, ${textColor.g}, ${textColor.b}, ${textColor.a})`;

    cachedColors[backgroundColorStr] = colorStr;
    return colorStr;
}

function blend(color, background) {
    let alpha = color.a;
    let oneMinusAlpha = 1 - alpha;

    let newColor = {};

    newColor.r = ((color.r * alpha) + (oneMinusAlpha * background.r));
    newColor.g = ((color.g * alpha) + (oneMinusAlpha * background.g));
    newColor.b = ((color.b * alpha) + (oneMinusAlpha * background.b));

    return newColor;
}

export function toOpaque(color) {

    const WHITE = {r: 255, g: 255, b: 255, a: 1};
    return blend(color, WHITE);
}

function hexToRgba(hex) {
    // Rimuove il cancelletto se presente
    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return { r, g, b, a: 1 };
}